import { useCallback } from 'react';
import { type GlobalSettings } from '#shared/api/schema';
import { useYandexKit } from '#shared/components/YandexKitProvider';

export const useConstructorMigrateGlobalSettings = () => {
    const { migrateGlobalSettings } = useYandexKit();

    return useCallback(
        (settings: unknown) => {
            if (migrateGlobalSettings) {
                return migrateGlobalSettings(settings);
            }

            return settings as GlobalSettings;
        },
        [migrateGlobalSettings]
    );
};
